import React, { useContext } from 'react'
import FormContext from './form-context'
import ValidationError from './validation-error'

const FormItem = ({ children, half, name, full, order, help }) => {
    const { i18n, errors, busy } = useContext(FormContext)

    return <div className={`${errors.has(name) ? 'has-errors' : ''} ${!full ? 'md:pr-6' : 'px-0'} py-4 form-item ${half ? 'w-full md:w-1/2' : 'w-full'} ${order === 'first' ? 'order-first' : 'order-none'} react-form-item`}>
        { React.cloneElement(children, {
            i18n,
            errors,
            busy,
            name,
        }) }

        { help ? <div className="mt-0.5 ml-0.5 text-sm text-grey-500">
            { help }
        </div> : null }

        { errors.has(name) && <ValidationError>
            { errors.get(name) }
        </ValidationError> }
    </div>
}

export default FormItem
